const messages_scopes = {
    MESSAGE_LIST : 'erp:message:history', // Get List of message	
    MESSAGE_SEND : 'erp:message:send', // Send a message
};

export default messages_scopes;
